import { useState, useEffect } from 'react';
import { getCarehomePartners } from '../api/profile';
import { ApiResponse } from '../typings/ApiResponse';
import { PartnerCarehomeData, PartnerCarehome } from '../typings/ProfileTypes';

const useCarehomePartners = () => {
  const [carehomePartnerList, setCarehomePartnerList] = useState<
    PartnerCarehome[]
  >([]);
  const [selectedPartnerId, setSelectedPartnerId] = useState<string | null>(
    null
  );
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const response: ApiResponse<PartnerCarehomeData[]> =
          await getCarehomePartners();
        if (response && response.status === 'success') {
          const transformedData = response.data.map(
            data => data.partner_carehome
          );
          setCarehomePartnerList(transformedData);

          // Partner selection logic
          if (transformedData.length > 0) {
            const storedPartnerId = localStorage.getItem('partnerId');
            if (storedPartnerId) {
              const existingPartner =
                transformedData.find(f => f.id === storedPartnerId) ?? null;
              setSelectedPartnerId(
                existingPartner?.id ?? transformedData[0].id
              );
            } else {
              setSelectedPartnerId(transformedData[0].id);
              localStorage.setItem('partnerId', transformedData[0].id);
            }
          }
        } else {
          setError('Failed to fetch carehome partners');
        }
      } catch (err) {
        setError('An error occurred while fetching carehome partners');
        console.error(err);
      }
    };

    fetchPartners();
  }, []);

  return {
    carehomePartnerList,
    selectedPartnerId,
    setSelectedPartnerId,
    error,
  };
};

export default useCarehomePartners;
